import alt, { AltStoreModel } from '../alt';
import ListingsManagementPageActions from './listings_management_page_actions';

const popupIds = [
  'uk_fee_change_data_informed_guidance',
  'uk_fee_change_new_filters',
];

interface State {
  usePriceRecommendations: boolean;
  currentPopupId: string;
  showPopups: boolean;
  popupsToShow: string[];
}

class ListingsManagementPageStore extends AltStoreModel<State> {
  usePriceRecommendations = false;

  showPopups = false;

  currentPopupId = '';

  popupsToShow = popupIds;

  constructor() {
    super();
    this.bindListeners({
      handleSetUsePriceRecommendations: ListingsManagementPageActions.SET_USE_PRICE_RECOMMENDATIONS,
      handleSetShowPopups: ListingsManagementPageActions.SET_SHOW_POPUPS,
      handleClosePopup: ListingsManagementPageActions.CLOSE_POPUP,
      handleRemovePopup: ListingsManagementPageActions.REMOVE_POPUP,
    });
  }

  handleSetUsePriceRecommendations(usePriceRecommendations) {
    this.usePriceRecommendations = usePriceRecommendations;
  }

  handleSetShowPopups(showPopups) {
    this.showPopups = showPopups;
    if (showPopups && this.popupsToShow.length) {
      this.currentPopupId = this.popupsToShow[0];
    } else {
      this.currentPopupId = '';
    }
  }

  handleRemovePopup(popupId) {
    if (this.currentPopupId === popupId) {
      this.handleClosePopup(popupId); // go to the next popup
    }
    this.popupsToShow = this.popupsToShow.filter(id => id != popupId);
  }

  handleClosePopup(popupId) {
    const currentIndex = this.popupsToShow.indexOf(popupId);
    const nextIndex = currentIndex + 1;

    if (nextIndex === this.popupsToShow.length) {
      this.showPopups = false;
      this.currentPopupId = '';
    } else {
      this.currentPopupId = this.popupsToShow[nextIndex];
    }
  }
}

export default alt.createStore(ListingsManagementPageStore, 'ListingsManagementPageStore');
